/* istanbul ignore file */
import KatalLogger, { Level } from '@amzn/katal-logger';

const katalLoggerConfig = {
  url: '/track/api/v1/log',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false,
};

export const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();
